<svg
  (mouseenter)="mouseEnter()"
  (mouseleave)="mouseLeave()"
  [attr.height]="height"
  [attr.width]="width"
  [class.cursor-pointer]="isButton"
  fill="none"
  viewBox="0 0 24 25"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M21.6781 7.6625C21.6781 7.6625 21.5781 7.6625 21.6781 7.6625L13.5781 15.7625C13.4781 15.8625 13.3781 15.9625 13.2781 15.9625C13.0781 16.1625 12.7781 16.2625 12.4781 16.2625C12.2781 16.2625 12.1781 16.3625 11.9781 16.3625C11.3781 16.3625 10.8781 16.1625 10.4781 15.7625L7.07812 12.3625C6.17812 11.4625 6.17812 10.1625 7.07812 9.2625C7.87813 8.4625 9.37813 8.4625 10.1781 9.2625L11.9781 11.0625L18.4781 4.5625C16.3781 3.5625 13.8781 3.7625 11.9781 5.1625C9.57812 3.3625 6.07812 3.5625 3.87813 5.7625L3.37813 6.1625C0.978125 8.5625 0.978125 12.5625 3.37813 15.0625L7.07812 18.7625L7.57812 19.2625C8.77812 20.4625 10.3781 21.0625 11.9781 21.0625C13.5781 21.0625 15.1781 20.4625 16.3781 19.2625L16.7781 18.8625L20.4781 15.1625C22.5781 13.0625 22.9781 10.0625 21.6781 7.6625Z"
    fill="#4AB8A7"
  />
</svg>
